export interface INotesDetails {
    title: {
        title: string;
        disableNumbering: boolean;
        number: string
    };
    components: {
        title: string;
        disableNumbering: boolean;
        number: string
    }[];
}
